import { Reveal, SectionHeading } from "./Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useLanguage } from "@/context/LanguageContext";

const Faq = () => {
  const { t } = useLanguage();

  const faqsList = [
    { q: t("faq.q1"), a: t("faq.a1") },
    { q: t("faq.q2"), a: t("faq.a2") },
    { q: t("faq.q3"), a: t("faq.a3") },
    { q: t("faq.q4"), a: t("faq.a4") },
    { q: t("faq.q5"), a: t("faq.a5") },
  ];

  return (
    <section id="faq" className="relative py-24 md:py-36 bg-[#f8fff8]" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-6 md:px-8">
        <SectionHeading
          eyebrow={t("faq.eyebrow")}
          title={`${t("faq.title")} ${t("faq.titleHighlight")}`}
          subtitle={t("faq.subtitle")}
          testid="faq"
          align="center"
        />

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-14 space-y-4" data-testid="faq-accordion">
            {faqsList.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border border-[#95d5b2]/40 rounded-2xl bg-white px-6 data-[state=open]:shadow-lg data-[state=open]:shadow-[#2d6a4f]/8 transition-shadow"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="font-display text-left text-[16px] md:text-lg font-medium text-[#222222] hover:no-underline py-5 [&>svg]:text-[#40916c]">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="font-body text-[15px] text-[#5b6b62] leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};

export default Faq;
